import React from 'react';
import styled from "styled-components";
import {ReactComponent as Icon} from '../assets/icons/iconmonstr-magnifier-text-lined.svg';


const IconoDetails = styled(Icon)`
height: 24px;
fill: #fff;
`


const IconDetails = () => {
    return ( 
        <>
            <IconoDetails></IconoDetails>
        </>
     );
}
 
export default IconDetails;